import QCActionTypes from "./wood-qc.types";

const INITIAL_STATE = {
	// general
	error: null,
	loading: false,
	plural: [],
};

const QCReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case QCActionTypes.CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case QCActionTypes.FETCH_QC_START:
			return {
				...state,
				loading: true,
			};
		case QCActionTypes.FETCH_QC_FAILURE:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		case QCActionTypes.FETCH_QC_SUCCESS: {
			return {
				...state,
				plural: action.payload,
				loading: false,
			};
		}
		default:
			return state;
	}
};

export default QCReducer;
